import React from "react"

const CheckIcon = ({ size, color = "currentColor" }) => {
	return (
		<svg viewBox="0 0 24 24" height={size} width={size} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="M19 2H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3z" fill={color} />
			<path d="M10.75 15.5a.997.997 0 0 1-.707-.293l-2.5-2.5a1 1 0 1 1 1.414-1.414l1.793 1.793 4.293-4.293a1 1 0 1 1 1.414 1.414l-5 5a.997.997 0 0 1-.707.293z" fill="white" />
		</svg>
	)
}

export default CheckIcon
